import React, { useRef } from "react";
import * as classes from "./pageSlider.module.scss";
import { CSSTransition, TransitionGroup } from "react-transition-group";

export default function PageSlider({ currentPage, onScroll }) {
  const { name, pageEl } = currentPage;

  // IMPORTANT: if you need to change the transition time, make sure to
  // also change the same transition time in these places:
  // -> SCSS animation time
  // -> slide pages that use a setTimeout before calling .focus() on
  //    the input elements (i.e. demoStepBusinessDetails.js)
  const transitionTimeMs = 500;
  const containerRef = useRef();
  const scrollToTop = () => {
    // Let's scroll back to the top of the container on state change
    containerRef?.current && containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className={classes.container}>
      <TransitionGroup component={null}>
        <CSSTransition
          onEntered={() => scrollToTop()}
          key={"page-" + name}
          classNames="page"
          appear={true}
          timeout={500}
        >
          <div className={classes.pageCtn} ref={containerRef} onScroll={onScroll}>
            {pageEl}
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
}
